import React from "react";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

import PredefinedPaymentPlanCardSkeleton from "../PredefinedPaymentPlanCardSkeleton/PredefinedPaymentPlanCardSkeleton";

// styles
import useStyles from "./styles";

function PredefinedPaymentPlanCardListSkeleton({ numberOfCards }) {
  const styles = useStyles();

  return (
    <>
      <Box className={styles.header}>
        <Skeleton animation="wave" variant="text" width="15%" height={45} />
      </Box>
      <Box className={styles.root}>
        {Array.from({ length: numberOfCards }, (_, index) => (
          <PredefinedPaymentPlanCardSkeleton key={index} />
        ))}
        ;
      </Box>
      <Box className={styles.scrollArrows}>
        <Skeleton animation="wave" variant="circle" width={34} height={34} />
        <Skeleton animation="wave" variant="circle" width={34} height={34} />
      </Box>
    </>
  );
}

export default PredefinedPaymentPlanCardListSkeleton;
